import * as React from 'react';

import { AppStore, AuthStore, DataStore, ErrorStore, FormStore } from 'stores';

const authStore = new AuthStore();
const appStore = new AppStore();
const errorStore = new ErrorStore();
const dataStore = new DataStore(authStore, appStore);
const formStore = new FormStore(authStore, appStore, dataStore, errorStore);

export const stores = {
  authStore,
  appStore,
  dataStore,
  errorStore,
  formStore,
};

export const storesContext = React.createContext(stores);
